import { withTranslatable } from '../modules/localization';

const Children = ({ children }) => children;

export default withTranslatable(Children);
